/**
 * EDIT FEED REDUX ACTIONS
 *
 * @version 0.1
 */

import reduxStore from './../../../reduxStore';
import xhr from './../../../utils/xhr';
import utils from './../../../utils/utilities';

const actions = {

    loadFeedInfo: (feedId) => {

        reduxStore.dispatch({type: 'SHOW_SPINNER'});

        xhr.get({
            url: '/api/feeds/' + feedId
        }).then((response) => {
            let newFeedData = response.body,
                feedData    = utils.deepClone(reduxStore.getState().addRssFeed);

            let thirdParties=null;

            // TODO: This needs cleanup (the addRssFeed Redux store should be modified so that no transformations are required to save the fetched feed info).
            feedData.feedInformation.feedName = newFeedData.title;

            if (newFeedData.metaData.selectAllThirdParties) {

                feedData.thirdParties.thirdPartySelectionBox = 'all-third-parties-section';

            } else if (newFeedData.metaData.categories.length > 0) {

                feedData.thirdParties.selectedCategories = newFeedData.metaData.categories;
                feedData.thirdParties.thirdPartySelectionBox = 'categories-section';

            } else if (newFeedData.metaData.thirdParties.length > 0){
                thirdParties = newFeedData.metaData.thirdParties;

                feedData.thirdParties.selectedThirdParties = [];
                for (let i = 0; i < thirdParties.length; i++) {
                    feedData.thirdParties.selectedThirdParties.push({id: thirdParties[i]});
                }

                feedData.thirdParties.thirdPartySelectionBox = 'specific-third-parties-section';

            } else {
                feedData.thirdParties.thirdPartySelectionBox = 'all-third-parties-section';
            }

            feedData.riskAngles = newFeedData.metaData.riskLevels;

            if (thirdParties) {
                let url = '/api/entities/specific-companies';

                xhr.post({
                    url: url,
                    data: thirdParties
                }).then((response)=> {
                    feedData.thirdParties.selectedThirdParties = response.body;
                    reduxStore.dispatch({
                        type:    'ADD_RSS_CHANGE_FEED_DATA',
                        payload: feedData
                    });

                    reduxStore.dispatch({type: 'HIDE_SPINNER'});
                }).catch((err) => {
                    console.log("********************** Failed to sync selection store ********************");
                    console.log(err);
                    xhr.handleAllErrors(err);
                });
            } else {
                reduxStore.dispatch({
                    type:    'ADD_RSS_CHANGE_FEED_DATA',
                    payload: feedData
                });

                reduxStore.dispatch({type: 'HIDE_SPINNER'});
            }
        }).catch((error) => {
            utils.logError(error, 'EditFeed.actions.loadFeedInfo(): ');
            reduxStore.dispatch({type: 'HIDE_SPINNER'});
            xhr.handleAllErrors(error);
        });

    },

    syncData: (data) => {
        let url = '/api/entities/specific-companies';
        reduxStore.dispatch(
            {
                type: 'SHOW_SPINNER'
            }
        );
        return xhr.post({
            url:  url,
            data: data
        }).then((response) => {
            actions.setSelectedItems(response.body);
            reduxStore.dispatch(
                {
                    type: 'HIDE_SPINNER'
                }
            );
        }).catch((err) => {
            console.log("********************** Failed to sync selection store ********************");
            console.log(err);
            xhr.handleAllErrors(err);
        });
    }

};

export default actions;


// WEBPACK FOOTER //
// ./src/scripts/pages/RSSEditing/EditFeed/EditFeed.actions.js